import React from 'react';

import Theme from 'styles/theme';

const QuestionIcon = () => (
  <span className="QuestionIcon">
    ?
    <style jsx>
      {`
        .QuestionIcon {
          width: 12px;
          height: 12px;
          border: 1px solid ${Theme.get('colors-error')};
          font-size: 9px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding-top: 1px;
        }
      `}
    </style>
  </span>
);

QuestionIcon.propTypes = {};

QuestionIcon.defaultProps = {};

export default QuestionIcon;
